define([
  'underscore',
  "i18n/i18n"
], function (
  _,
  i18n
) {

function loadHTMLAsync(path) {
  return new Promise(function(resolve, reject) {
    const fullDep = "text!" + path;

    Mindbreeze.require([fullDep], function success(moduleValue) {
      resolve(moduleValue);
    }, function errback(err) {
      reject(err || new Error(`Load failed: ${fullDep}`));
    });
  });
}

  function tryGetDescriptor(el, ctx) {
    var descriptorEl = el.querySelector("script[type='application/json'][data-name=descriptor]");
    if (descriptorEl) {
      try {
        return JSON.parse(descriptorEl.innerText);
      } catch (e) {
        console.warn("Failed to parse descriptor, skipping.", ctx, e);
      }
    }
    return null;
  }

  function tryGetSchema(el, ctx) {
    var schemaText = el.getAttribute("data-schema");
    if (!schemaText) {
      var schemaEl = el.querySelector("template[data-name=schema]");
      if (schemaEl) {
        schemaText = schemaEl.innerHTML;
      }
    }
    return tryParseSchema(schemaText, ctx);
  }
  
  function tryParseSchema(schemaString, ctx) {
    ctx = ctx || "";
    if (schemaString) {
      try {
        return JSON.parse(schemaString);
      } catch (e) {
        console.warn("Failed to parse schema, skipping.", ctx, e);
      }
      return null;
    }            
    return null;
  }

  function buildFragment(templateEl, appfragment, ctx) {
    var baseDescriptor = tryGetDescriptor(templateEl, ctx) || {};
    var schema = tryGetSchema(templateEl, ctx);
    if (schema) {
      baseDescriptor.schema = schema;
    }
    appfragment.storeProperties = { storeId: "readonlyDOMAppFragmentStoreAPI", writeable: false };
    return _.extend(baseDescriptor, appfragment);
  }
  
  function ReadonlyDOMAppFragmentStoreAPI(options) {
    this.options = options || {};

    let locations = this.options.locations || [];
    if (this.options.location) {
      locations.push(this.options.location);
    }

    if (!locations || locations.length === 0) {
      this.documentPromise = Promise.resolve(options.el || document);
      return;
    }

    this.documentPromise = Promise.all(
      locations.map(loc =>
        loadHTMLAsync(loc)
          .then(html => {
            if (!html) return null;
            const template = document.createElement("template");
            template.innerHTML = html;
            return template.content;
          })
          .catch(() => null)   
      )
    ).then(fragments => {
      const container = document.createDocumentFragment();
      fragments.filter(Boolean).forEach(frag => {
        container.appendChild(frag);
      });
      i18n.patchI18nAttributes(container)
      return container;
    });
  }

  _.extend(ReadonlyDOMAppFragmentStoreAPI.prototype, {

    get: function (id) {
      return this.fragmentList.find(function (fragment) { fragment.id === id });
    },

    findFirstByTypeAndNames: function (appType, appNames) {

      var templateElement = null;
      return this.documentPromise.then(function (rootEl) {
        var appName = null;
        for (var i = 0; i < appNames.length; ++i) {
          appName = appNames[i];
          templateElement = rootEl.querySelector('[data-app-fragment-type="' + appType + '"][data-app-fragment-name="' + appName + '"]');
          if (templateElement) {
            break;
          }
        }

        return new Promise(function (resolve, reject) {
          if (!templateElement) {
            reject({});
          }
          else {
            var ctx = "app=" + appType + "." + appName;
            resolve(buildFragment(
              templateElement,
              {
                id: templateElement.id,
                type: appType,
                name: appName,
                htmlFragment: templateElement.innerHTML,
              },
              ctx));
          }
        });
      });
    },

    getByTypeAndName: function (appType, appName) {
      return this.documentPromise.then(function (rootEl) {

        var templateElement = rootEl.querySelector('[data-app-fragment-type="' + appType + '"][data-app-fragment-name="' + appName + '"]');
        return new Promise(function (resolve, reject) {
          if (!templateElement) {
            reject({});
          }
          else {
            var ctx = "app=" + appType + "." + appName;
            resolve(buildFragment(
              templateElement,
              {
                id: templateElement.id,
                type: appType,
                name: appName,
                htmlFragment: templateElement.innerHTML,
              },
              ctx));
          }
        });
      })
    },
                                      

    getAllAppDescriptions: function (appType, options) {

      return this.documentPromise.then(function (rootEl) {
          
        return new Promise(function(res, rej) {
          var selector = '[data-app-fragment-type]';
          if (appType) {
            selector = '[data-app-fragment-type="' + appType + '"]';
          }
          
          var templateElements = rootEl.querySelectorAll(selector);
          
          if (!templateElements.length) {
            return res([]);
          } else {
            const listItemsArray = Array.from(templateElements);
            var list = listItemsArray.map(function(templateElement) {
              var appType = templateElement.getAttribute('data-app-fragment-type');
              var appName =  templateElement.getAttribute('data-app-fragment-name');
              var ctx = "app=" + appType + "." + appName;
              return buildFragment(
                templateElement,
                {
                  id: templateElement.id,
                  type: appType,
                  name: appName,
                  htmlFragment: templateElement.innerHTML,
                },
                ctx);
            });
            return res(list);
          }
        });
      });
    },

    getStoreId: function() {
      return "readonlyAppFragmentStore";
    },
  
    isWriteable:function() {
      return false;
    }

  });

  return ReadonlyDOMAppFragmentStoreAPI;
});
